<template>
	<v-app>
		<v-data-table
			:headers="headers"
			:items="projects"
			:hide-default-footer="false"
			:items-per-page="50"
			sort-by="id"
			@click:row="handleClick"
			:footer-props = "{ 'items-per-page-options':[15, 30, 50, 100, -1], 'items-per-page-text' : '行/ページ:' }"
		>
			<template v-slot:top>
				<v-toolbar flat>
					<v-toolbar-title>プロジェクト一覧</v-toolbar-title
					><v-btn class="add" @click.stop="newItem"
						>プロジェクトを追加</v-btn
					>
				</v-toolbar>
			</template>
			<template v-slot:[`item.actions`]="{ item }">
				<v-btn class="user-add" @click.stop="newUser(item)"
						>招待</v-btn
					>
				<v-icon small class="edit" @click="editItem(item)">
					mdi-pencil
				</v-icon>
			</template>
		</v-data-table>

		<v-footer>
			©2021 <a href="https://www.vegetalia.co.jp/">vegetalia</a>, inc.
		</v-footer>
	</v-app>
</template>

<script>
import axios from "axios";

export default {
	components: {},
	data: () => ({
		isLoading: false,
		headers: [
			{ text: "名称", value: "name" },
			{
				text: "ID",
				align: "start",
				value: "id",
			},
			{ text: "招待コード", value: "code" },
			{ text: "最終更新日時", value: "createdAt" },
			{ text: "", value: "actions", sortable: false },
		],
		editedIndex: -1,
		projects: [],
	}),
	created() {
		axios.defaults.headers.common["Authorization"] =
			"Bearer " + this.$store.state.auth.data.token;
		this.initialize();
	},
	methods: {
		initialize() {
			this.showLoading();
			axios
				.get(
					"https://" +
						this.config.defaultOriginString +
						"/api/admin-projects"
				)
				.then((res) => {
					this.hideLoading();
					// 成功した場合
					if (res && res.data && res.data.status == "success") {
						this.projects = res.data.projects;
						console.log("Success: " + JSON.stringify(res.data));
					} else {
						console.log("Fail: " + JSON.stringify(res));
					}
				})
				.catch((error) => {
					this.hideLoading();
					console.log(error);
				});
		},
		editItem(item) {
			this.$router
				.push({ name: "AdminEditProject", params: { id: item.id } })
				.catch(() => {});
		},
		newItem() {
			this.$router.push({ name: "AdminEditProject" }).catch(() => {});
		},
		newUser(item) {
			this.$router
				.push({ name: "AdminInviteUser", params: { id: item.id, name: item.name } })
				.catch(() => {});
		},
		showLoading: function () {
			this.$emit("loadShowHide", true);
		},
		hideLoading: function () {
			this.$emit("loadShowHide", false);
		},
		handleClick(value, e) {
			console.log(e.index);
			e.select(!e.isSelected);
		},
	},
};
</script>

<style>
</style>
